import { createBrowserRouter } from "react-router-dom";
import { MainLayout } from "@/layouts/MainLayout";
import { HomePage } from "@/pages/HomePage/HomePage";
import { CategoryPage } from "@/pages/CategoryPage/CategoryPage";
import { ArticlePage } from "@/pages/ArticlePage/ArticlePage";
import { ProfilePage } from "@/pages/ProfilePage/ProfilePage";
import { UsernameSetupPage } from "@/pages/UsernameSetupPage/UsernameSetupPage";
import { CallbackPage } from "@/pages/CallbackPage/CallbackPage";
import { NotFoundPage } from "@/pages/NotFoundPage/NotFoundPage";

export const router = createBrowserRouter([
  {
    element: <MainLayout />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/kategorija/:categoryName", element: <CategoryPage /> },
      { path: "/clanak/:id", element: <ArticlePage /> },
      { path: "/profil", element: <ProfilePage /> },
      { path: "/postavi-ime", element: <UsernameSetupPage /> },
      { path: "/callback", element: <CallbackPage /> },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
